/* eslint-disable react/require-default-props */
/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */

import React from 'react';
import { connect } from 'react-redux';

import { useTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonCurrency, selectCurrentSalonId } from 'selectors/currentSalon.selectors';

import ReportTableV2 from 'reports/Common/ReportTableV2';
import { generateRetailPerformanceTable } from 'reports/utils';

const SalonPerformanceTable = ({ salonId, revenueData, salesReport, uniqueClientsReport, currency, startDate, endDate }) => {
  const { t } = useTranslation();
  return (
    <div className="performance p5">
      <div id="retail-performance">
        <div className="retail-btn-container">
          <ReportTableV2
            data={generateRetailPerformanceTable(
              revenueData,
              salesReport.stylist_group.filter((s) => s.products_sold_count !== 0),
              uniqueClientsReport,
              salesReport.visits,
              currency,
            )}
            title={t('businessReports.retail.retailPerformance')}
            startDate={startDate}
            endDate={endDate}
            linkText={t('businessReports.retail.viewMoreStockReports')}
            linkUrl={`/salon/${salonId}/stocks/usedSoldOverDateRange`}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  currency: selectCurrentSalonCurrency(state),
  salonId: selectCurrentSalonId(state),
});

const SalonPerformanceTableHoc = connect(mapStateToProps)(SalonPerformanceTable);

export default SalonPerformanceTableHoc;
